import React from 'react'
import 'regenerator-runtime/runtime'
import Settings from '../../routes/Profile/Settings'
import Head from 'next/head'

const Metatags = () => (
  <Head>
    <title>Account Settings - DecorMatters</title>
    <meta
      name="description"
      content="Edit your DecorMatters profile, personalize account, and manage security and plans."
    />
    <meta name="twitter:card" content="summary" />
    <meta
      name="twitter:site"
      content={`https://www.decormatters.com/settings`}
    />
    <meta name="twitter:title" content="Account Settings - DecorMatters" />
    <meta name="twitter:site" content="@decormattersapp" />
    <meta property="og:url" content={`https://www.decormatters.com/settings`} />
    <meta property="og:title" content="Account Settings - DecorMatters" />
    <meta
      property="og:description"
      content="Edit your DecorMatters profile, personalize account, and manage security and plans."
    />
  </Head>
)

const Routes = () => {
  if (typeof window === 'undefined') return <Metatags />
  return (
    <>
      <Metatags />
      <Settings />
    </>
  )
}

export default Routes
